var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"catalog__list"},_vm._l((_vm.products),function(product){return _c('li',{key:product.id,staticClass:"catalog__item"},[_c('ProductItem',{attrs:{"product":product}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }